import { IActivity } from '@sdk/contracts';
import { Button } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UnsyncActivityConfirmation } from '../UnsyncActivityConfirmation';

import { Icon } from '@/components/Icon';

type Props = {
  activity: IActivity;
};

export const UnsyncActivityAction: React.FC<Props> = ({ activity }) => {
  const { t } = useTranslation('CoursesTranslations');
  const [isUnsyncActivityModalOpen, setIsUnsyncActivityModalOpen] = useState(false);
  return (
    <>
      <UnsyncActivityConfirmation
        activity={activity}
        isModalOpen={isUnsyncActivityModalOpen}
        setIsModalOpen={setIsUnsyncActivityModalOpen}
      />

      <Button
        type="text"
        icon={<Icon i="IbmDataReplication" size={16} />}
        onClick={e => {
          e.stopPropagation();
          setIsUnsyncActivityModalOpen(true);
        }}>
        {t('UNSYNC_ACTIVITY')}
      </Button>
    </>
  );
};
